import {
  GET_INTERNET_USAGE,
  GET_INTERNET_USAGE_SUCCESS,
  GET_INTERNET_USAGE_FAILURE,
} from '../actions/usage';

const INITIAL_STATE = { loading: true, requested: false };

export default function usage(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_INTERNET_USAGE:
      return {
        ...state, loading: true, requested: true, error: null,
      };
    case GET_INTERNET_USAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        cacheValid: true,
        data: action.payload,
      };
    case GET_INTERNET_USAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
